import { Link } from "@material-ui/core";
import React from "react";

function Info() {
  return (
    <div>
      <Link href="https://github.com/CJ-arg" color="secondary" underline="none" target="_blank" className="linkMode">
        Github
      </Link>
    </div>
  );
}

export default Info;
